import GitHubIcon from '@mui/icons-material/GitHub';
import Computer from '@mui/icons-material/Computer';
import './Projeto.css'

const Projeto = (props)=>{

    return(
       
        <div>
            <div className="card" >
                <header>
                   <div className="cardActions">
                   {props.liveLink ?
                        <a target='blank' className='projectCta' href={props.liveLink}>
                            <Computer style={{ fontSize: 20 }}/>
                            <span>Ver site</span>
                        </a>
                    : ''}
                    {props.repoLink ?
                        <a target='blank' href={props.repoLink} className='projectCta'>
                            <GitHubIcon style={{ fontSize: 20 }}></GitHubIcon>
                            <span>Codigo</span>
                        </a>
                    : ''}
                   </div>
                    <h1>{props.titulo}</h1>
                </header>
                <p>{props.descricao}</p>
            </div>
            
        </div>
    )
}

export default Projeto
